if (!customElements.get('fatio-payment-widgets')) {
  customElements.define('fatio-payment-widgets', class extends HTMLElement {
    connectedCallback() {
      this.section = document.getElementById('shopify-section-' + this.dataset.sectionId);
      this.variants = JSON.parse(this.querySelector('[data-payment-variants]').textContent);
      this.onVariantChange = (event) => {
        if (event.target.matches('[name="id"]')) this.updateAmount(event.target.value);
      };
      this.section.addEventListener('change', this.onVariantChange);
      this.tabby = this.querySelector('.fatio-payment-widgets__tabby');
      this.styleObserver = new MutationObserver(() => this.styleTabby());
      this.styleObserver.observe(this.tabby, { childList: true, subtree: true });
      this.styleTabby();
      const selected = this.section.querySelector('product-form input[name="id"]');
      if (selected) this.updateAmount(selected.value);
    }
    disconnectedCallback() {
      this.section?.removeEventListener('change', this.onVariantChange);
      this.styleObserver?.disconnect();
    }
    styleTabby() {
      const walk = (root) => {
        for (const element of root.querySelectorAll('*')) {
          if (!element.shadowRoot) continue;
          const shadow = element.shadowRoot;
          if (!shadow.querySelector('[data-fatio-payment-style]')) {
            const style = document.createElement('style');
            style.dataset.fatioPaymentStyle = '';
            style.textContent = '@media (max-width: 749px) { [class*="SnippetDefault__SnippetDefault__Content--"] { flex-direction: column-reverse; align-items: flex-start; gap: 8px; padding: 10px; min-height: 168px; } [class*="SnippetContent__SnippetContent--"] { margin: 0 !important; min-width: 0; width: 100%; } [class*="SnippetContent__SnippetContent__Text--"] { align-self: flex-start; } }';
            shadow.appendChild(style);
            this.styleObserver.observe(shadow, { childList: true, subtree: true });
          }
          walk(shadow);
        }
      };
      walk(this.tabby);
    }
    updateAmount(id) {
      const variant = this.variants.find((item) => String(item.id) === String(id));
      if (!variant) return;
      const widget = this.querySelector('tamara-widget');
      const amount = String(variant.price / 100);
      if (widget.getAttribute('amount') !== amount) {
        widget.setAttribute('amount', amount);
        window.TamaraWidgetV2?.refresh();
      }
    }
  });
}
